<template>
  <div>
    <b-card class="mb-0">
      <div v-if="!loader">
        <b-row class="d-flex justify-content-between" style="padding: 0 15px">
          <b-tabs
              v-model="tabIndex"
              content-class="pt-1"
          >
            <b-tab
                v-for="(currency, index) in currencies"
                :key="currency.id"
                @click="changeTab(currency.id, currency.name, index)"
            >
              <template #title>
                <span>{{ currency.name }}</span>
              </template>
            </b-tab>
          </b-tabs>
          <div>
            <span v-if="this.$store.state.auth.user.crole != 'seller' && this.$store.state.auth.user.crole != 'partner'">{{ $t('investment_profile_heading') }}
              <span v-if="data.autoInvestmentStatus" class="text-success"> {{ $t('active') }}</span>
              <span v-else class="text-danger"> {{ $t('inactive') }}</span>
            </span>
          </div>
        </b-row>
        <b-row
            v-if="this.$store.state.auth.user.crole != 'seller' && this.$store.state.auth.user.crole != 'partner'"
            class=" ml-auto justify-center"
        >
          <b-card
              class="col-xl-5 col-lg-6 col-md-6 col-xs-12 m-1"
              no-body
              style="border: 1px solid lightgray"
          >
            <b-card-body class="row justify-content-between align-items-start">
              <!-- Saldo Balance -->
              <b-col
                  md="6"
                  sm="6"
                  class="mb-2 mb-md-0 col-md-6 mt-1 mb-1"
              >
                <div
                    class="truncate col-md-12"
                    align="start"
                >
                  <h6>{{ $t("saldo_balance") }}</h6>
                  <h2
                      class="mb-25 font-weight-bolder"
                      style="color:#1B4332 ;"
                  >
                    <span v-if="data.openBalance">
                      <!--{{ CurrencyAmountFormat(data.openBalance, currency.name ) }}-->
                      {{ amountFormat(data.openBalance, currency.name) }}
                    </span>
                    <span v-else>{{ amountFormat("00’000.00", currency.name) }}</span>
                  </h2>
                </div>
              </b-col>

              <!-- Purchased Invoices -->

              <b-col
                  md="6"
                  sm="6"
                  class="mb-2 mb-md-0 col-md-6 mt-1 mb-1"
              >
                <b-media no-body>
                  <b-media-aside class="mr-2">
                    <b-avatar
                        size="48"
                        variant="light-primary"
                    >
                      <feather-icon
                          size="24"
                          icon="FileTextIcon"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body
                      v-if="authUser.crole != 'seller'"
                       class="my-auto"
                  >
                    <h4 class="font-weight-bolder mb-0">
                        <span v-if="data.invoicesPurchased">{{
                            data.invoicesPurchased
                          }}</span>
                      <span v-else>0</span>
                    </h4>
                    <b-card-text class="font-small-3 mb-0">
                      {{ $t("purchased_invoices_fractions") }}
                    </b-card-text>
                  </b-media-body>
                  <b-media-body
                      v-else
                      class="my-auto"
                  >
                    <h4 class="font-weight-bolder mb-0">
                        <span v-if="data.invoicesPurchased">
                          {{ currency.name }} {{ data.invoicesPurchased }}</span>
                      <span v-else>{{ amountFormat("00’000.00", currency.name) }}</span>
                    </h4>
                    <b-card-text class="font-small-3 mb-0">
                      {{ $t("invoices_sold") }}
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>

              <!-- Invested Amount -->

              <b-col
                  md="6"
                  sm="6"
                  class="mb-2 mb-md-0 col-md-6 mt-1 mb-1"
              >
                <div
                    v-if="authUser.crole != 'seller'"
                    class="truncate col-md-12"
                    align="start"
                >
                  <h6>{{ $t("allocated_amount") }}</h6>
                  <h2 class="mb-25 font-weight-bolder">
                    <span v-if="data.allocated">
                      {{ amountFormat(data.allocated, currency.name) }}
                    </span>
                    <span v-else>{{ amountFormat("00’000.00", currency.name) }}</span>
                  </h2>
                </div>
              </b-col>

              <!-- Settled Inovices -->

              <b-col
                  v-if="authUser.crole != 'seller'"
                  md="3"
                  sm="6"
                  class="mb-2 mb-md-0 col-md-6 mt-1 mb-1"
              >
                <b-media no-body>
                  <b-media-aside class="mr-2">
                    <b-avatar size="48" variant="light-primary" >
                      <feather-icon size="24" icon="FileTextIcon" color="#0a9104" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <h4 class="font-weight-bolder mb-0">
                        <span v-if="data.settledInvoices">{{
                            data.settledInvoices
                          }}</span>
                      <span v-else>0</span>
                    </h4>
                    <b-card-text class="font-small-3 mb-0">
                      {{ $t("settled_invoice") }}
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>

            </b-card-body>
          </b-card>
          <b-card
              no-body
              class="card-statistics col-xl-6 col-lg-6 col-md-6 col-xs-12 m-1"
              style="border: 1px solid lightgray"
          >
            <b-card-body class="statistics-body">
              <b-row>
                <b-col
                    v-if="authUser.crole == 'seller'"
                    md="3"
                    sm="6"
                    class="mb-2 mb-md-0 col-md-6 mt-1 mb-1"
                >
                  <b-media no-body>
                    <b-media-aside class="mr-2">
                      <b-avatar
                          size="48"
                          variant="light-success"
                      >
                        <feather-icon
                            size="24"
                            icon="DollarSignIcon"
                        />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body class="my-auto">
                      <h4 class="font-weight-bolder mb-0">
                        <span v-if="data.amountOutstanding && data.amountOutstanding != 0">

                          {{ amountFormat(data.amountOutstanding, currency.name) }}

                        </span>
                        <span v-else>{{ currency.name }}  00’000.00</span>
                      </h4>
                      <b-card-text class="font-small-3 mb-0">
                        {{ $t("outstanding_amount") }}
                      </b-card-text>
                    </b-media-body>
                  </b-media>
                </b-col>

                <!-- Purchased Volume-->
                <b-col
                    md="3"
                    sm="6"
                    class="mb-2 mb-md-0 col-md-6 mt-1 mb-1"
                >
                  <b-media no-body>
                    <b-media-aside class="mr-2">
                      <b-avatar
                          size="48"
                          variant="light-success"
                      >
                        <feather-icon
                            size="24"
                            icon="DollarSignIcon"
                        />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body
                        v-if="authUser.crole != 'seller'"
                        class="my-auto"
                    >
                      <h4 class="font-weight-bolder mb-0">

                        <span v-if="data.amountPurchased">
                          {{ amountFormat(data.amountPurchased, currency.name) }}
                        </span>
                        <span v-else>{{ amountFormat("00’000.00", currency.name) }}</span>

                      </h4>
                      <b-card-text class="font-small-3 mb-0">
                        {{ $t("purchased_volume") }}
                      </b-card-text>
                    </b-media-body>
                    <b-media-body
                        v-else
                        class="my-auto"
                    >
                      <h4 class="font-weight-bolder mb-0">
                        <!--<span v-if="data.amountPurchased">{{ currency.name }} {{ data.amountPurchased | formatAmount }}</span>-->
                        <!--<span v-else>{{ amountFormat("00’000.00", currency.name ) }}</span>-->
                      </h4>
                      <b-card-text class="font-small-3 mb-0">
                        {{ $t("sold_volume") }}
                      </b-card-text>
                    </b-media-body>
                  </b-media>
                </b-col>

                <!-- Net Return -->

                <b-col
                    md="3"
                    sm="6"
                    class="mb-2 mb-md-0 col-md-6 mt-1 mb-1"
                    v-if="authUser.crole != 'seller'"
                >
                  <b-media no-body>
                    <b-media-aside>
                      <b-avatar size="48" variant="light-success" class="relative">
                        <div style="position: absolute;left: 8px;">
                          <b-avatar size="20" style="background-color: #fcd34d; color: #fff;">
                            <feather-icon
                                class="absolute top-[2px] left-[6px] text-gray-700"
                                size="15"
                                icon="DollarSignIcon"
                            />
                          </b-avatar>
                        </div>

                        <div style="position: absolute;left: 20px;">
                          <b-avatar size="20" style="background-color: #fcd34d; color: #fff;">
                            <feather-icon
                                class="absolute top-[2px] left-[6px] text-gray-700"
                                size="15"
                                icon="DollarSignIcon"
                            />
                          </b-avatar>
                        </div>
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body class="my-auto" >
                      <h4 class="font-weight-bolder mb-0">
                        <span v-if="data.totalNetReturn">
                          {{ amountFormat(data.totalNetReturn, currency.name) }}
                        </span>
                        <span v-else>{{ amountFormat("00’000.00", currency.name) }}</span>
                      </h4>
                      <b-card-text class="font-small-3 mb-0">
                        {{ $t("net_return_v_2") }}
                      </b-card-text>
                    </b-media-body>
                  </b-media>
                </b-col>

                <!-- Outstanding Expected Net Return-->

                <b-col
                    md="3"
                    sm="6"
                    class="mb-2 mb-md-0 col-md-6 mt-1 mb-1"
                    v-if="authUser.crole != 'seller'"
                >
                  <b-media no-body>
                    <b-media-aside class="mr-2">
                      <b-avatar
                          size="48"
                          variant="light-primary"
                      >
                        <feather-icon
                            size="24"
                            icon="TrendingUpIcon"
                        />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body class="my-auto" >
                      <h4 class="font-weight-bolder mb-0">
                        <span v-if="data.amountOutstanding">
                          {{ amountFormat(data.amountOutstanding, currency.name) }}
                        </span>
                        <span v-else>{{ amountFormat("00’000.00", currency.name) }}</span>
                      </h4>
                      <b-card-text class="font-small-3 mb-0">
                        {{ $t("outstanding_expected_net_return") }}
                      </b-card-text>
                    </b-media-body>
                  </b-media>
                </b-col>

                <b-col
                    v-if="authUser.crole == 'seller'"
                    md="3"
                    sm="6"
                    class="mb-2 mb-md-0 col-md-6 mt-1 mb-1"
                >
                  <b-media no-body>
                    <b-media-aside class="mr-2">
                      <b-avatar
                          size="48"
                          variant="light-success"
                      >
                        <feather-icon
                            size="24"
                            icon="DollarSignIcon"
                        />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body class="my-auto">
                      <h4 class="font-weight-bolder mb-0">
                        <span v-if="data.yieldSoFar && data.yieldSoFar != 0">
                          {{ amountFormat(data.yieldSoFar, currency.name) }}
                        </span>
                        <span v-else>{{ amountFormat("00’000.00", currency.name) }}</span>
                      </h4>
                      <b-card-text class="font-small-3 mb-0">
                        {{ $t("yield_so_far") }}
                      </b-card-text>
                    </b-media-body>
                  </b-media>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-row>

        <b-row
            v-else-if="$store.state.auth.user.crole == 'partner'"
            class="col-12 ml-ato"
        >
          <b-card
              no-body
              class="card-statistics col-xl-12 col-lg-12 col-md-12 col-xs-12"
              style="border: 1px solid lightgray"
          >
            <b-card-body class="statistics-body">
              <b-row>
                <b-col
                    md="4"
                    sm="4"
                    class="mb-2 mb-md-0 col-md-4 mt-1 mb-2"
                >
                  <b-media no-body>
                    <b-media-aside class="mr-2">
                      <b-avatar
                          size="58"
                          variant="light-success"
                      >
                        <feather-icon
                            size="34"
                            icon="DollarSignIcon"
                        />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body class="my-auto">
                      <h3 class="font-weight-bolder mb-0">
                        <span v-if="balance && balance.openBalance">
                          {{ amountFormat(data.openBalance, currency.name) }}
                        </span>
                        <span v-else>{{ amountFormat("00'000.00", currency.name) }}</span>
                      </h3>
                      <b-card-text class="font-small-3 mb-0">
                        {{ $t("saldo_balance") }}
                      </b-card-text>
                    </b-media-body>
                  </b-media>
                </b-col>

                <b-col
                    md="4"
                    sm="4"
                    class="mb-2 mb-md-0 col-md-4 mt-1 mb-2"
                >
                  <b-media no-body>
                    <b-media-aside class="mr-2">
                      <b-avatar
                          size="58"
                          variant="light-primary"
                      >
                        <feather-icon
                            size="34"
                            icon="UsersIcon"
                        />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body class="my-auto">
                      <h3 class="font-weight-bolder mb-0">
                        <span v-if="balance && balance.amountOutstanding !== undefined">
                          {{ balance.amountOutstanding }}
                        </span>
                        <span v-else>0</span>
                      </h3>
                      <b-card-text class="font-small-3 mb-0">
                        {{ $t("referred_sellers") }}
                      </b-card-text>
                    </b-media-body>
                  </b-media>
                </b-col>

                <b-col
                    md="4"
                    sm="4"
                    class="mb-2 mb-md-0 col-md-4 mt-1 mb-2"
                >
                  <b-media no-body>
                    <b-media-aside class="mr-2">
                      <b-avatar
                          size="58"
                          variant="light-primary"
                      >
                        <feather-icon
                            size="34"
                            icon="UsersIcon"
                        />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body class="my-auto">

                      <h3 class="font-weight-bolder mb-0">
                        <span v-if="balance && balance.totalNetReturn !== undefined">
                          {{ balance.totalNetReturn }}
                        </span>
                        <span v-else>0</span>
                      </h3>
                      <b-card-text class="font-small-3 mb-0">
                        {{ $t("referred_buyers") }}
                      </b-card-text>
                    </b-media-body>
                  </b-media>
                </b-col>

              </b-row>
            </b-card-body>
          </b-card>
        </b-row>

        <b-row
            v-else-if="$store.state.auth.user.crole == 'seller'"
            class="col-12 ml-ato"
        >
          <b-card
              no-body
              class="card-statistics col-xl-12 col-lg-12 col-md-12 col-xs-12"
              style="border: 1px solid lightgray"
          >
            <b-card-body class="statistics-body">
              <b-row>
                <b-col
                    md="4"
                    sm="4"
                    class="mb-2 mb-md-0 col-md-4 mt-1 mb-2"
                >
                  <b-media no-body>
                    <b-media-aside class="mr-2">
                      <b-avatar
                          size="58"
                          variant="light-success"
                      >
                        <feather-icon
                            size="34"
                            icon="DollarSignIcon"
                        />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body class="my-auto">
                      <h3 class="font-weight-bolder mb-0">
                        <span v-if="balance && balance.openBalance">
                          {{ amountFormat(data.openBalance, currency.name) }}
                        </span>
                        <span v-else>{{ amountFormat("00’000.00", currency.name) }}</span>
                      </h3>
                      <b-card-text class="font-small-3 mb-0">
                        {{ $t("liquidity_received") }}
                      </b-card-text>
                    </b-media-body>
                  </b-media>
                </b-col>

                <b-col
                    md="4"
                    sm="4"
                    class="mb-2 mb-md-0 col-md-4 mt-1 mb-2"
                >
                  <b-media no-body>
                    <b-media-aside class="mr-2">
                      <b-avatar
                          size="58"
                          variant="light-primary"
                      >
                        <feather-icon
                            size="34"
                            icon="TrendingUpIcon"
                        />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body class="my-auto">
                      <h3 class="font-weight-bolder mb-0">
                        <span v-if="balance && balance.invoicesPurchased">
                          <!--                            {{ amountFormat(balance.invoicesPurchased, currency.name) }}-->
                          {{ balance.invoicesPurchased }}
                        </span>
                        <!--                        <span v-else>{{ amountFormat("00’000.00", currency.name) }}</span>-->
                        <span v-else>0</span>
                      </h3>
                      <b-card-text class="font-small-3 mb-0">
                        {{ $t("invoices_sold") }}
                      </b-card-text>
                    </b-media-body>
                  </b-media>
                </b-col>

                <b-col
                    md="4"
                    sm="4"
                    class="mb-2 mb-md-0 col-md-4 mt-1 mb-2"
                >
                  <b-media no-body>
                    <b-media-aside class="mr-2">
                      <b-avatar
                          size="58"
                          variant="light-success"
                      >
                        <feather-icon
                            size="34"
                            icon="DollarSignIcon"
                        />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body class="my-auto">
                      <h3 class="font-weight-bolder mb-0">
                        <span v-if="balance && balance.amountOutstanding">
                          {{ amountFormat(balance.amountOutstanding, currency.name) }}
                        </span>
                        <span v-else>{{ amountFormat("00’000.00", currency.name) }}</span>
                      </h3>
                      <b-card-text class="font-small-3 mb-0">
                        {{ $t("amount_outstanding") }}
                      </b-card-text>
                    </b-media-body>
                  </b-media>
                </b-col>

                <!--                <b-col md="4" sm="4" class="mb-2 mb-md-0 col-md-4 mt-1 mb-2">-->
                <!--                  <b-media no-body>-->
                <!--                    <b-media-aside class="mr-2">-->
                <!--                      <b-avatar size="58" variant="light-success">-->
                <!--                        <feather-icon size="34" icon="DollarSignIcon"/>-->
                <!--                      </b-avatar>-->
                <!--                    </b-media-aside>-->
                <!--                    <b-media-body class="my-auto">-->
                <!--                      <h3 class="font-weight-bolder mb-0">-->
                <!--                        <span v-if="balance && balance.budgetBalance">-->
                <!--                            {{ amountFormat(balance.budgetBalance, currency.name) }}-->
                <!--                        </span>-->
                <!--                        <span v-else>{{ amountFormat("00’000.00", currency.name) }}</span>-->
                <!--                      </h3>-->
                <!--                      <b-card-text class="font-small-3 mb-0">-->
                <!--                        {{ $t("budget_balance") }}-->
                <!--                      </b-card-text>-->
                <!--                    </b-media-body>-->
                <!--                  </b-media>-->
                <!--                </b-col>-->

              </b-row>
            </b-card-body>
          </b-card>
        </b-row>
      </div>
      <div v-else>
        <img src="/new-loader.svg">
      </div>
    </b-card>

    <b-card
        class="mt-2 mb-0"
    >

      <b-tabs
          v-model="transactionTabIndex"
          content-class="pt-1"
      >
        <b-tab @click="changeTransactionTabs('transaction')">
          <template #title>
            <span>{{ $t('transaction') }}</span>
          </template>
        </b-tab>

        <!--        <b-tab @click="changeTransactionTabs('exchange')">-->
        <!--          <template #title>-->
        <!--            <span>{{ $t('exchange') }}</span>-->
        <!--          </template>-->
        <!--        </b-tab>-->
        <b-tab
            v-if="$store.state.auth.user.company.role == &quot;buyer&quot;"
            @click="changeTransactionTabs('option_tab')"
        >
          <template #title>
            <span>{{ $t('option_tab') }}</span>
          </template>
        </b-tab>
      </b-tabs>

      <b-col
          md="12"
          class="mb-5"
      >
        <Table
            :url="url"
            :fields="fields"
            :payload="payload"
            :updateData="url + payload.currency_id + refetch_data"
            :reactiveFields="true"
        >

          <template #cell(admin_transaction_reason)="data">
            <span v-html="renderTransactionReason(data.item)"></span>
          </template>

          <template #cell(amount11)="data">
            <span v-if="data.item.amount">{{ amountFormat(data.item.amount, data.item.currency.name) }}</span>
            <span v-else>{{ amountFormat(data.item.crypto_amount, data.item.currency.name) }}</span>
          </template>
          <template #cell(fee_hive_amount)="data">
            <span>{{ amountFormat(data.item.fee_hive_amount, data.item.currency.name) }}</span>
          </template>
          <template #cell(exchange_amount)="data">
            <span v-if="data.item.exchange_amount">{{
                amountFormat(data.item.exchange_amount, data.item.exchange_currency.name)
              }}</span>
            <span v-else>{{ amountFormat(data.item.exchange_crypto_amount, data.item.exchange_currency.name) }}</span>
          </template>
          <template #head()="scope">
            <div class="text-nowrap">
              {{ $t(scope.label) }}
            </div>
          </template>
          <template #cell(currency)="data">
            <span>{{ data.item.currency.name }}</span>
          </template>
          <template #cell(id)="data">
            <span
                style="width:55px;"
                class="badge badge-light-secondary"
            >T-{{ data.value }}</span>
          </template>
          <template #cell(type_description)="data">
            <span v-if="authUser.crole == 'seller' && data.item.type_description == 'Purchase' ">
              {{ $t("sold") }}</span>
            <span
                v-else-if="data.item.type_description == 'invoice_sold' || data.item.type_description == 'invoice_paid'"
            >  {{
                $t("invoice_paid")
              }}</span>
            <span
                v-else-if="data.item.type_description == 'ExchangeFrom' || data.item.type_description == 'ExchangeTo'"
            >  {{
                $t("Exchange")
              }}</span>
            <span v-else>  {{ $t("" + data.item.type_description) }}</span>
          </template>

          <template #cell(fraction)="data">
            <span v-if="data.item.fraction">
              {{ data.item.fraction.fraction }}%
            </span>
            <span v-else>- </span>
          </template>
          <!--<template #cell(financing_status)="data">-->
          <!--<span v-if="data.item">-->
          <!--{{ data.item.discount_percentage }} %-->
          <!--</span>-->
          <!--<span v-else>- </span>-->
          <!--</template>-->
          <template #cell(fraction_amount)="data">
            <span v-if="data.item.fraction">
              {{ data.item.amount | formatAmountWithoutCurrency }}
            </span>
            <span v-else>{{
                data.item.amount | formatAmountWithoutCurrency
              }}</span>
          </template>
          <template #cell(fraction_discount)="data">
            <span v-if="data.item.fraction">
              {{ data.item.fraction.discount }}%
            </span>
            <span v-else>-</span>
          </template>
          <template #cell(fraction_hive_fee)="data">
            <span v-if="data.item.fraction">
              {{ data.item.fraction.hive_fee | formatAmount }}
            </span>
            <span v-else>-</span>
          </template>
          <template #cell(invoice_id)="data">
            <span
                v-if="data.item.invoice_id != null && data.item.invoice_id != 0"
                style="width:55px;"
                class="badge badge-light-primary"
            >
              I-{{ data.item.invoice_id }}
            </span>
            <span v-else>-</span>
          </template>
          <template #cell(fraction_net_return)="data">
            <span v-if="data.item.fraction">
              {{ data.item.fraction.net_return | formatAmount }}
            </span>
            <span v-else>-</span>
          </template>

          <template #cell(created_at)="data">
            <span v-if="data.item.created_at">{{
                data.item.created_at | formatDate
              }}</span>
            <span v-else>-</span>
          </template>
          <template #cell(directions)="data">
            <feather-icon
                :icon="isSuccessIcon(data.item) ? 'ArrowUpCircleIcon' : 'ArrowDownCircleIcon'"
                :class="isSuccessIcon(data.item) ? 'text-success' : 'text-danger'"
            />
          </template>
          <template #cell(amount)="data">
            {{ amountFormat(data.item.amount, data.item.currency.name) }}
          </template>
          <template #cell(discount)="data">
            <span v-if="data.item.type_description != 'Refund'">
              {{ amountFormat(data.item.discount, data.item.currency.name) }}
            </span>
            <span v-else>
              {{ amountFormat(0, data.item.currency.name) }}
            </span>
          </template>
          <template #cell(status)="data">
            <span
                v-if="data.value == 0"
                class="text-secondary"
            >{{ $t("pending") }}
            </span>
            <span
                v-if="data.value == 1"
                class="text-success"
            >{{
                $t("approved")
              }}</span>
            <span
                v-if="data.value == 2"
                class="text-danger"
            >{{
                $t("declined")
              }}</span>
          </template>
          <template #cell(action)="data">
            <div style="min-width: 160px">
              <b-button
                variant="outline-secondary"
                size="sm"
                @click="showModal(data.item)"
              >
                <feather-icon icon="SearchIcon" />
              </b-button>
              <b-button
                class="ml-1 web"
                variant="outline-success"
                size="sm"
                @click="readInvoice(data.item)"
                v-if="data.item.type_description != 'Deposit' && data.item.type_description != 'Withdraw' && data.item.type_description != 'referral_program_reward'"
              >
                <FeatherIcon icon="BookOpenIcon" />
              </b-button>
              <template v-if="data.item.cancel_transaction_status === 0 && data.item.type_description == 'Option' && $store.state.auth.user.company.role == 'buyer'">
                <b-button
                    class="mt-1 mobile"
                    variant="outline-success"
                    size="sm"
                    @click="downloadPdf(data.item)"
                >
                  <FeatherIcon icon="DownloadIcon" />
                </b-button>
                <b-button
                  v-if="clientType(['all_in_access','trade_only_access'])"
                  class="ml-1 web"
                  variant="outline-danger"
                  size="sm"
                  @click="openCancelOptionModal(data.item)"
                >
                  <feather-icon icon="XIcon" />
                </b-button>
              </template>
            </div>
          </template>
        </Table>
      </b-col>

    </b-card>

    <b-modal
        id="bv-modal-example"
        size="lg"
        centered
        hide-footer
        :title="$t('details')"
    >
      <b-card-text
          v-if="singleItem"
          class="text-left"
      >
        <h5>{{ $t("transaction_id") }} : {{ singleItem.id }}</h5>
        <h5>
          {{ $t("transaction_data") }} :
          {{ singleItem.created_at | formatDate }}
        </h5>
        <hr>
        <div class="row">
          <div class="col-md-6">
            <h5>{{ $t("transaction") }} :</h5>
            <div>
              {{ $t("status") }} :
              <span
                  v-if="singleItem.status == 0"
                  class="text-secondary"
              >{{ $t("pending") }}
              </span>
              <span
                  v-if="singleItem.status == 1"
                  class="text-success"
              >{{
                  $t("approved")
                }}</span>
              <span
                  v-if="singleItem.status == 2"
                  class="text-danger"
              >{{
                  $t("declined")
                }}</span>
            </div>
            <div>
              {{ $t("type") }} :
              <span class="text-primary">{{
                  $t(singleItem.type_description)
                }}</span>
            </div>
            <div>
              {{ $t("direction") }} :
              <feather-icon
                  :icon="isSuccessIcon(singleItem) ? 'ArrowUpCircleIcon' : 'ArrowDownCircleIcon'"
                  :class="isSuccessIcon(singleItem) ? 'text-success' : 'text-danger'"
              />
            </div>
            <div>
              {{ $t("currency") }} : <span class="text-primary">{{ singleItem.currency.name }}</span>
            </div>
            <div v-if="authUser.crole != 'seller' && singleItem && singleItem.invoice">
            </div>
            <div v-else>
              {{ $t("net_amount_sold") }}:
              <span class="text-primary">
                {{ singleItem.amount | formatAmountWithoutCurrency }}
              </span>
            </div>
          </div>
          <div
              v-if="singleItem.invoice!=null && (singleItem.invoice_id != null || singleItem.invoice_id !=0) "
              class="col-md-6"
          >
            <h5>{{ $t("invoice_details") }} :</h5>
            <div>
              {{ $t("investment_amount") }} :
              <span
                  v-if="singleItem.fraction"
                  class="text-primary"
              >
                {{ amountFormat(CalculationsHelper.getInvestmentAmount(singleItem.invoice, singleItem.fraction.fraction), singleItem.currency.name) }}
              </span>
              <span v-else>
                {{ amountFormat(singleItem.amount, singleItem.currency.name) }}
              </span>
            </div>
            <div v-if="authUser.crole != 'seller'">
              {{ $t("expected_return") }} :
              <span
                  v-if="singleItem.fraction"
                  class="text-primary"
              >
                {{ amountFormat(CalculationsHelper.getInvestorRoiAmount(singleItem.invoice, singleItem.fraction.fraction), singleItem.currency.name) }}
              </span>
            </div>
            <div v-if="authUser.crole != 'seller'">
              {{ singleItem.company }}
              {{ $t("roi_in_%") }} :

              <span
                  v-if="singleItem.fraction"
                  class="text-primary"
              >
                <!--                ~{{ calculatePercent(singleItem.fraction.amount, singleItem.fraction.net_return) }}-->
                ~{{ CalculationsHelper.getInvestorRoiPercentage(singleItem.invoice) }}

              </span>

            </div>
            <div>
              {{ $t("issue_date") }} :
              <span class="text-primary">
                {{ singleItem.invoice.created_at | formatDate }}</span>
            </div>
            <div>
              {{ $t("due_date") }} :
              <span class="text-primary">
                {{ singleItem.invoice.due_date | formatDate }}</span>
            </div>
            <div>
              {{ $t("payment_term") }} :
              <span class="text-primary">
                {{ singleItem.invoice.terms }}
              </span>
            </div>
            <div v-if="authUser.crole != 'seller'">
              {{ $t("seller_industry") }} :
              <span
                  v-if="
                  singleItem.invoice &&
                    singleItem.invoice.company &&
                    singleItem.invoice.company.credit_reform &&
                    singleItem.invoice.company.credit_reform[0] &&
                    singleItem.invoice.company.credit_reform[0].industry
                "
                  class="text-primary"
              >
                {{ JSON.parse(singleItem.invoice.company.credit_reform[0].industry)[$store.state.app.language] }}
              </span>
              <span
                  v-else-if="
                  singleItem.invoice &&
                    singleItem.invoice.company &&
                    singleItem.invoice.company.description
                "
              >
                {{ JSON.parse(singleItem.invoice.company.description)[$store.state.app.language] }}
              </span>
            </div>
            <div v-if="authUser.crole != 'seller'">
              {{ $t("debtor_industry") }} :
              <span
                  v-if="
                  singleItem.invoice.debtor &&
                    singleItem.invoice.debtor.credit_reform &&
                    singleItem.invoice.debtor.credit_reform[0] &&
                    singleItem.invoice.debtor.credit_reform[0].industry
                "
                  class="text-primary"
              >
                {{ JSON.parse(singleItem.invoice.debtor.credit_reform[0].industry)[$store.state.app.language] }}
              </span>
              <span
                  v-else-if="
                  singleItem.invoice &&
                    singleItem.invoice.debtor &&
                    singleItem.invoice.debtor.description
                "
              >

                {{ JSON.parse(singleItem.invoice.debtor.description)[$store.state.app.language] }}

              </span>
            </div>

            <br><br>
          </div>
          <div
              v-if="singleItem.invoice_id != null && singleItem.fraction"
              class="col-md-6"
          >
            <h5>{{ $t("invoice_transaction") }} :</h5>
            <div>
              {{ $t("invoice_id") }} :
              <span class="text-primary">I-{{ singleItem.invoice.id }}</span>
            </div>
            <div v-if="authUser.crole != 'seller'">
              {{ $t("fraction") }} :
              <span
                  class="text-primary"
              >{{ singleItem.fraction.fraction }}%</span>
            </div>
            <div v-else>
              {{ $t("funding_status") }} :
              <span class="text-primary">100%</span>
            </div>
            <div>
              {{ $t("seller_id") }} :
              <span class="text-primary">C-{{
                  singleItem.invoice.company.id
                }}</span>
            </div>
            <div>
              {{ $t("debtor_id") }} :
              <span class="text-primary">
                C-{{ singleItem.invoice.debtor.id }}</span>
            </div>
          </div>
          <div
              v-if="singleItem.invoice_id != null && singleItem.invoice != null"
              class="col-md-6"
          >
            <!--<div>-->
            <!--{{ $t("market") }} :-->
            <!--<span class="text-primary"> Switzerland </span>-->
            <!--</div>-->

            <div>
              {{ $t("invoice_id") }} :
              <span
                  v-if="singleItem.invoice"
                  class="text-primary"
              > I-{{ singleItem.invoice.id }} </span>
              <span v-else>-</span>
            </div>
            <div>
              {{ $t("asset_class") }} :
              <span class="text-primary"> Invoice receivable </span>
            </div>
            <div>
              {{ $t("payment_term") }} :
              <template v-if="singleItem.invoice.is_reverse != 1">
                <span
                    v-if="singleItem.invoice.recourse == 1"
                    class="text-primary"
                >
                  Silent; Recourse
                </span>
                <span
                    v-else
                    class="text-primary"
                >
                  Open; Non-Recourse
                </span>
              </template>
              <template v-else>
                <span class="text-primary">
                  Silent; Reverse
                </span>
              </template>
            </div>

            <div>
              {{ $t("origin_of_creditor") }} :
              <span class="text-primary"> {{ singleItem.invoice.company.country.name }} </span>
            </div>
            <div>
              {{ $t("origin_of_debtor") }} :
              <span class="text-primary"> {{ singleItem.invoice.debtor.country.name }} </span>
            </div>
            <!--<div>-->
            <!--{{ $t("sale") }} : <span class="text-primary">Normal</span>-->
            <!--</div>-->
          </div>
        </div>
      </b-card-text>
      <hr>
    </b-modal>

    <b-modal
        v-model="cancel_option"
        @ok="cancelOption"
    >
      do you really want to cancel share of {{ remove_transaction_fraction }}% for I-{{ remove_transaction ? remove_transaction.invoice.id : null }}
    </b-modal>

  </div>
</template>
<script>
import Table from '@/components/common/Table2.vue'
import ApproveModal from '@/components/common/ApproveModal'
import fileDownload from 'js-file-download'
import { CurrencyAmountFormat } from '@core/utils/CurrencyAmountFormat'
import CalculationsHelper from "@/helpers/calculationsHelper";

export default {
  components: { Table, ApproveModal },
  props: {
    transactionTableType: String,
    currencyTo: Object,
  },
  data() {
    return {
      CalculationsHelper,
      remove_transaction: null,
      remove_transaction_fraction: null,
      cancel_option: false,
      refetch_data: 0,
      transactionType: 'transaction',
      payload: null,
      exchange_payload: null,
      data: [],
      transactions: [],
      exchanges: [],
      options: [],
      loader: false,
      fields: null,
      transaction_fields: [
        {
          label: 'date',
          align: 'start',
          key: 'created_at',
        },
        {
          label: 'status',
          key: 'status',
          customSlot: true,
          sortable: false,
        },
        {
          label: 'type',
          align: 'start',
          key: 'type_description',
          sortable: false,
        },
        {
          label: 'id',
          align: 'start',
          key: 'id',
          sortable: false,
        },
        {
          label: 'invoice_id',
          align: 'start',
          key: 'invoice_id',
          sortable: false,
        },
        {
          label: 'directions',
          align: 'center',
          key: 'directions',
          sortable: false,
        },
        {
          label: 'currency',
          align: 'start',
          key: 'currency',
          sortable: false,
        },
        {
          label: 'amount',
          align: 'right',
          key: 'amount',
          sortable: false,
          tdClass: 'text-right',
          thClass: 'text-right',
        },
        {
          label: 'fee',
          align: 'right',
          key: 'discount',
        },
        {
          label: 'fraction',
          align: 'start',
          key: 'fraction',
          sortable: false,
        },
        {
          label: 'Reason',
          align: 'start',
          key: 'admin_transaction_reason',
        },
        {
          label: 'action',
          align: 'start',
          key: 'action',
          sortable: false,
        },
      ],
      transaction_fields_seller: [
        {
          label: 'date',
          align: 'start',
          key: 'created_at',
        },
        {
          label: 'status',
          key: 'status',
          customSlot: true,
          sortable: false,
        },
        {
          label: 'type',
          align: 'start',
          key: 'type_description',
          sortable: false,
        },
        {
          label: 'id',
          align: 'start',
          key: 'id',
          sortable: false,
        },
        {
          label: 'invoice_id',
          align: 'start',
          key: 'invoice_id',
          sortable: false,
        },
        {
          label: 'directions',
          align: 'center',
          key: 'directions',
          sortable: false,
        },
        {
          label: 'currency',
          align: 'start',
          key: 'currency',
          sortable: false,
        },
        {
          label: 'amount',
          align: 'right',
          key: 'amount',
          sortable: false,
          tdClass: 'text-right',
          thClass: 'text-right',
        },
        {
          label: 'discount',
          align: 'right',
          key: 'discount',
        },
        {
          label: 'Reason',
          align: 'start',
          key: 'admin_transaction_reason',
        },
        {
          label: 'action',
          align: 'start',
          key: 'action',
          sortable: false,
        },
      ],
      exchange_fields: [
        {
          label: this.$t('amount'),
          key: 'amount11',
        },
        {
          label: this.$t('exchange_amount'),
          key: 'exchange_amount',
        },
        {
          label: this.$t('fee_hive_amount'),
          key: 'fee_hive_amount',
        },
        {
          label: this.$t('fee_hive_percentage'),
          key: 'fee_hive_percentage',
        },
        {
          label: this.$t('status'),
          key: 'status',
        },
        // {
        //   label: "actions",
        //   key: "actions"
        // }
      ],

      option_fields: [
        {
          label: 'date',
          align: 'start',
          key: 'created_at',
        },
        {
          label: 'status',
          key: 'status',
          customSlot: true,
          sortable: false,
        },
        {
          label: 'type',
          align: 'start',
          key: 'type_description',
          sortable: false,
        },
        {
          label: 'id',
          align: 'start',
          key: 'id',
          sortable: false,
        },
        {
          label: 'directions',
          align: 'center',
          key: 'directions',
          sortable: false,
        },
        {
          label: 'currency',
          align: 'start',
          key: 'currency',
          sortable: false,
        },
        {
          label: 'amount',
          align: 'right',
          key: 'amount',
          sortable: false,
          tdClass: 'text-right',
          thClass: 'text-right',
        },
        {
          label: 'fee',
          align: 'right',
          key: 'discount',
        },
        {
          label: 'invoice_id',
          align: 'start',
          key: 'invoice_id',
          sortable: false,
        },
        {
          label: 'fraction',
          align: 'start',
          key: 'fraction',
          sortable: false,
        },
        {
          label: 'Reason',
          align: 'start',
          key: 'admin_transaction_reason',
        },
        {
          label: 'action',
          align: 'start',
          key: 'action',
          sortable: false,
        },
      ],

      dialog: false,
      invoice: null,
      items: [],
      singleItem: null,
      type: '',
      base64: '',
      isLoading: false,
      totalItems: 0,
      currentPage: 1,
      exchangeTotalItems: 0,
      exchangeCurrentPage: 1,
      optionsTotalItems: 0,
      optionsCurrentPage: 1,
      // perPage: 12,
      invoices: [],
      balance: null,
      url: null,
      exchange_url: '/currency/get-transactions',
      transaction_url: '/transactions',
      option_url: '/transactions/options',
      currencies: null,
      tabIndex: 0,
      transactionTabIndex: 0,
      balanceCancelTokenSource: null,
      currency: {
        name: 'CHF',
        id: 1,
      },
    }
  },
  computed: {

    authUser() {
      return this.$store.state.auth.user
    },

    liquidity_received() {
      return this.$store.state.app.company.value.buyer
    },
    rows() {
      return this.totalItems
    },

    // ytdLabel() {
    //   const today = new Date()
    //   const start = new Date(today.getFullYear(), 0, 1)
    //   const format = d => d.toISOString().slice(0, 10)
    //   return `YTD ${format(start)} - ${format(today)}`
    // },

  },
  watch: {
    transactionTableType(newValue, oldValue) {
      this.changeTransactionTabs(newValue)
    },
  },
  created() {
    this.changeTransactionTabs('transaction')
    this.getBalance()
    this.getTransactions()
    this.getExchanges()
    this.getOptions()
    this.getCurrencies()
    // if (this.seller == 0) {
    //
    // } else {
    //   this.fields[9] = {
    //     label: 'fraction',
    //     align: 'start',
    //     key: 'fraction',
    //     sortable: false,
    //   }
    // }
  },

  methods: {
    isSuccessIcon(transaction) {
      const successTypes = [
        'Refund',
        'Deposit',
        'Completed',
        'ExchangeTo',
        'invoice_sold',
        'invoice_paid',
        'refund_defaults',
        'refund_not_defaults',
        'referral_program_reward'
      ];

      const isSuccessType = transaction ? successTypes.includes(transaction.type_description) : false;

      const isSellerPurchase = this.authUser.crole === 'seller' && transaction && transaction.type_description === 'Purchase';

      return isSuccessType || isSellerPurchase;
    },

    openCancelOptionModal(transaction) {
      this.remove_transaction = transaction
      this.cancel_option = true
      this.remove_transaction_fraction = this.remove_transaction.fraction.fraction
    },

    cancelOption() {
      this.$http.post(`/transactions/remove-option/${this.remove_transaction.id}`).then(response => {
        if (response.data.status == 200) {
          this.changeTransactionTabs('option_tab');

          const index = this.currencies.findIndex(
              currency => currency.id === this.remove_transaction.currency.id
          );

          this.changeTab(this.remove_transaction.currency.id,
              this.remove_transaction.currency.name, index);
        }
      })
    },

    renderTransactionReason(item) {
      if (!item) return '-'

      // We need to check if admin_transaction_reason or purpose of payment exists then show it
      const adminReason = this.getReason(item)
      if (adminReason) return adminReason

      const { invoice_id, type_description, fraction } = item
      const role = this.authUser.crole

      if (invoice_id && ['Purchase', 'Option'].includes(type_description)) {
        // When user is buyer and has fraction
        if (role === 'buyer' && fraction) {
          const label = type_description === 'Purchase' ? this.$t('purchased') : this.$t('Option')

          const fractionText = fraction.fraction ? `${fraction.fraction}% ` : ''

          return `<span>${label}</span> <span>${fractionText}</span> ${this.$t('of')} <span> I-${invoice_id}</span>`
        }

        return `I-${invoice_id}`
      }

      return '-'
    },

    getReason(transaction) {
      if (!transaction) return null

      let reason = null

      if (transaction.admin_transaction_reason) {
        try {
          const parsed = JSON.parse(transaction.admin_transaction_reason)
          const lang = this.$store.state.app.language
          reason = parsed?.[lang] || null
        } catch (err) {
          console.error('Invalid JSON in admin_transaction_reason:', err)
        }
      } else if (transaction.purpose_payment) {
        reason = transaction.purpose_payment
      }

      return reason
    },

    // calculatePercent(amount, net_return) {
    //   return (net_return * 100 / amount).toFixed(2)
    // },

    changeTransactionTabs(type) {
      this.transactionType = type

      switch (type) {
        case 'exchange':
          if (this.url === this.transaction_url) {
            this.refetch_data++;
          } else {
            this.url = this.transaction_url;
          }
          this.fields = this.$store.state.auth.user.crole == 'seller'
              ? this.transaction_fields_seller
              : this.transaction_fields;
          this.transactionTabIndex = 0;

          const index = this.currencies.findIndex(
              currency => currency.id === this.currencyTo.currencyTo
          );
          this.changeTab(this.currencyTo.currencyTo, this.currencies[index].name, index);

          break;

        case 'transaction':
          this.url = this.transaction_url;
          this.fields = this.$store.state.auth.user.crole == 'seller'
              ? this.transaction_fields_seller
              : this.transaction_fields;
          this.transactionTabIndex = 0;
          break;

        case 'option_tab':
          this.url = this.option_url;
          this.fields = this.option_fields;
          this.transactionTabIndex = 2;
          break;
      }
    },

    amountFormat(amount, currency) {
      return CurrencyAmountFormat(amount, currency)
    },

    changeTab(id, name, tabIndex) {
      this.currency.name = name
      this.currency.id = id
      this.tabIndex = tabIndex
      this.getBalance(id)
    },
    getCurrencies() {
      this.$http.post('/currency').then(response => {
        if (response.data.status == 200) {
          this.currencies = response.data.value
        }
      })
    },

    getInvoices() {
      // this.loader = true
      // this.$http.post(`/market/invoices/status/${10}`).then(res => {
      //   if (res) {
      //     this.invoices = res.data.value.data
      //     this.loader = false
      //   }
      // })
    },
    InvoiceDetails(record, index) {
      this.$router.push(`/market/${record.id}`)
    },
    downloadPdf(item) {
      this.$http
          .post(
              `/invoice/fraction/download/${item.fraction_id}`,
              {},
              {
                responseType: 'blob',
              },
          )
          .then(response => {
            fileDownload(response.data, item.invoice.title)
          })
          .catch(error => {
            this.isLoading = false
          })
    },
    readInvoice(item) {
      this.$http
          .post(`/invoice/fraction/read/${item.fraction_id}`, {
            responseType: 'json',
          })
          .then(response => {
            this.type = ''
            this.base64 = ''

            this.base64 = response.data.value.b64
            this.type = response.data.value.ext

            this.$store.commit('app/SET_FILE_TYPE', this.type)
            this.$store.commit('app/SET_FILE_BASE64', this.base64)

            window.open('/read-files', '_blank')
          })
          .catch(error => {
            this.isLoading = false
          })
    },
    showModal(item) {
      let itemClone = structuredClone(item);
      itemClone.invoice.scoring = itemClone.invoice.scorings[0];
      this.singleItem = itemClone;
      this.$bvModal.show('bv-modal-example')
    },
    myRowClickHandler(record, index) {
      this.singleItem = record.fraction
      if (this.singleItem) {
        this.dialog = true
      }
    },
    getTransactions(id = 1) {
      if (this.payload?.currency_id === id)
        this.refetch_data++;

      this.payload = { company_id: this.$store.state.auth.user.company_id, currency_id: id };
    },

    getExchanges() {
      this.$http.post(`/currency/get-transactions?page=${this.currentPage}`).then(res => {
        if (typeof res.data.value.data !== 'undefined' && res.data.value.data) {
          this.exchanges = res.data.value.data
          this.exchangeTotalItems = res.data.value.total
          this.exchangeCurrentPage = res.data.value.current_page
        }
        this.loader = false
      })
    },

    getOptions() {
      this.$http.post(`/transactions/options?page=${this.currentPage}`).then(res => {
        if (typeof res.data.value.data !== 'undefined' && res.data.value.data) {
          this.options = res.data.value.data
          this.optionsTotalItems = res.data.value.total
          this.optionsCurrentPage = res.data.value.current_page
        }
        this.loader = false
      })
    },

    getBalance(id = 1) {
      // Cancel previous getBalance request if exists
      if (this.balanceCancelTokenSource) {
        this.balanceCancelTokenSource.cancel('New balance request initiated');
      }

      // Create new cancel token
      const axios = require('axios');
      this.balanceCancelTokenSource = axios.CancelToken.source();

      this.loader = true;
      this.getTransactions(id);

      this.$http.post('/transactions/getBalance',
          {currency_id: id},
          {cancelToken: this.balanceCancelTokenSource.token}
      ).then(res => {
        if (typeof res.data.value !== 'undefined' && res.data.value) {
          this.data = res.data.value;
          this.balance = res.data.value;
        }
        this.loader = false;
        this.balanceCancelTokenSource = null;
      }).catch(error => {
        const axios = require('axios');
        if (!axios.isCancel(error)) {
          this.loader = false;
        }
        this.balanceCancelTokenSource = null;
      });
    },
  },
  beforeDestroy() {
    if (this.balanceCancelTokenSource) {
      this.balanceCancelTokenSource.cancel('Component destroyed');
    }
  }
}
</script>
